// /src/utils/runtimeEnv.js
// Client-side env detection for view-as mutation affordances (must match backend FRONTEND_URL rules).

/**
 * True on localhost / loopback, or the dedicated staging host (dev.pallas-invictus.com).
 * False on production (pallas-invictus.com). Never enable view-as writes on prod.
 */
export function allowsViewAsMutations() {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') return true;
  if (host === 'dev.pallas-invictus.com') return true;
  return false;
}
